/* Adapters own content only. The existing Shop owner owns all modal/history state. */
(() => {
  window.createRareTCGMobileSearchAdapter = (dialog, owner, source) => {
    let placeholder;
    const input = source.querySelector('input[type="search"]');
    const discovery = source.querySelector('[data-rtcg-search-discovery]');
    const close = () => {
      if (!placeholder) return;
      source.abortController?.abort();
      source.requestGeneration = (source.requestGeneration || 0) + 1;
      source.rtcgMobileSuspended = true;
      source.close?.();
      if (discovery) discovery.hidden = true;
      delete source.dataset.rtcgMobileOwned;
      delete source.dataset.rtcgPreserveMobilePanel;
      source.rtcgMobileNavigate = null;
      source.rtcgMobileStatus = null;
      source.resultsMaxHeight = false;
      source.querySelector('[data-predictive-search]')?.removeAttribute('style');
      placeholder.replaceWith(source);
      placeholder = null;
      document.body.classList.remove('rtcg-search-open');
    };
    return {
      open() {
        placeholder = document.createComment('RareTCG search original slot');
        source.before(placeholder);
        source.close?.();
        source.rtcgMobileSuspended = false;
        source.dataset.rtcgMobileOwned = 'true';
        source.rtcgMobileNavigate = url => owner.navigate(url);
        source.rtcgMobileStatus = state => {
          if (!dialog.open) return;
          const status = dialog.querySelector('[data-rtcg-search-status]');
          const error = dialog.querySelector('[data-rtcg-search-error]');
          if (status) status.textContent = state === 'loading' ? 'Searching…' : '';
          if (error) error.hidden = state !== 'error';
        };
        source.rtcgMobileStatus('idle');
        dialog.querySelector('[data-rtcg-search-host]').append(source);
        document.body.classList.remove('rtcg-search-open');
        // Intentionally no promise, animation frame or timer before focus.
        input.focus({ preventScroll: true });
        if (discovery) discovery.hidden = !!input.value.trim();
      },
      close,
      restoreFocus(opener) {
        if (opener !== source && opener?.getClientRects?.().length) return false;
        if (!input.getClientRects?.().length) return false;
        source.rtcgMobileRestoringFocus = true;
        input.focus({ preventScroll: true });
        source.rtcgMobileRestoringFocus = false;
        return true;
      },
      destroy: close
    };
  };
  window.initRareTCGMobileLayers = () => {
    const owner = document.querySelector('[data-rtcg-shop]')?.rtcgShop;
    if (!owner) return;
    const search = document.querySelector('[data-rtcg-search-layer]');
    const source = document.querySelector('.header .raretcg-header-search');
    if (search && source && !owner.layers.has('search')) {
      owner.registerLayer('search', search, window.createRareTCGMobileSearchAdapter(search, owner, source));
      owner.searchSource = source;
      owner.searchSection = source.closest('.shopify-section');
    }
    const cart = document.querySelector('[data-rtcg-cart-layer]');
    if (cart && window.createRareTCGMobileCartAdapter && !owner.layers.has('cart')) {
      owner.registerLayer('cart', cart, window.createRareTCGMobileCartAdapter(cart, owner));
    }
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
    const owner = document.querySelector('[data-rtcg-shop]')?.rtcgShop;
    if (!owner?.mobile.matches) return;
    // Resolve through the composed event path instead of relying only on the
    // deepest target. This keeps taps deterministic when the user lands on an
    // SVG path, badge, image or other decorative child inside a full-cell
    // mobile destination.
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    const fromPath = selector => path.find(node => node?.matches?.(selector));
    const headerEntry = fromPath('.header .raretcg-header-search') || event.target.closest?.('.header .raretcg-header-search');
    const opener = fromPath('[data-rtcg-search-open], [data-rtcg-cart-open]') || event.target.closest?.('[data-rtcg-search-open], [data-rtcg-cart-open]') || headerEntry;
    if (!opener) return;
    const name = headerEntry || opener.hasAttribute('data-rtcg-search-open') ? 'search' : 'cart';
    // Basket already has a CartItems engine; keep that page rather than duplicate it.
    if (name === 'cart' && document.querySelector('cart-items.rtcg-cart-page')) return;
    if (!owner.layers.has(name)) return;
    // Re-check ownership synchronously at tap time (see raretcg-mobile-shell.js
    // for the matching Shop-opener guard) so a tap right after an external
    // panel closes is not dropped for up to ~500ms of stale reconciliation.
    const nowExternal = owner.hasExternalOwner();
    if (owner.externalOwner !== nowExternal) owner.syncOwnership(nowExternal);
    if (nowExternal) return;
    if (headerEntry) {
      owner.searchSource.close?.();
      owner.searchSource.querySelector('[data-rtcg-search-discovery]')?.setAttribute('hidden', '');
      document.body.classList.remove('rtcg-search-open');
    }
    event.preventDefault();
    event.stopPropagation();
    owner.activeDialog.open ? owner.switchTo(name, opener) : owner.openLayer(name, opener);
  }, true);
  // Bubble after SearchForm/predictive validation and capture intent enrichment.
  document.addEventListener('submit', event => {
    const form = event.target;
    const dialog = form.closest('[data-rtcg-search-layer], [data-rtcg-cart-layer]');
    if (!dialog?.open || event.defaultPrevented || form.method.toLowerCase() !== 'get') return;
    const owner = document.querySelector('[data-rtcg-shop]')?.rtcgShop;
    if (owner?.activeDialog !== dialog) return;
    const url = new URL(form.action, window.location.href);
    new FormData(form).forEach((value, key) => url.searchParams.append(key, value));
    if (event.submitter?.name) url.searchParams.append(event.submitter.name, event.submitter.value);
    event.preventDefault();
    owner.navigate(url.href);
  });
  document.addEventListener('shopify:section:load', () => window.initRareTCGMobileLayers());
  document.addEventListener('shopify:section:unload', event => {
    const owner = document.querySelector('[data-rtcg-shop]')?.rtcgShop;
    if (owner?.searchSection === event.target) {
      owner.reset();
      owner.layers.get('search')?.adapter.destroy();
      owner.layers.delete('search');
    }
  });
  window.initRareTCGMobileLayers();
})();
